import { CompanyDTO } from "api/model/company/CompanyDTO";
import { useUserState } from "../store/user-store";

const useCurrentCompanyContext = (): CompanyDTO | undefined => {
  return useUserState(state => state.companyContext);
};

export default useCurrentCompanyContext;
